import { ColDef, ValueFormatterParams } from 'ag-grid-community';
import { capitalize } from 'lodash-es';
import { FormatterService } from '../../../../util/formatter-service';
import { RendererType } from '../../../../data-models/field-definition';
import { getLiquidationPreference } from './CTInvestmentDetailsColDefs';

export const ColDefOverrides: Record<string, ColDef> = {
  ['name']: {
    width: 200,
    pinned: 'left',
    valueFormatter: (params: ValueFormatterParams) => {
      if (params.node?.footer) {
        return 'Total';
      }
      return params.value ?? '';
    },
  },
  ['compoundingPeriod']: {
    valueFormatter: capitalizer,
  },
  ['interestType']: {
    valueFormatter: capitalizer,
  },
  ['securityType']: {
    valueFormatter: (params: ValueFormatterParams) => {
      if (params.value == null) {
        return '';
      }
      return params.value.split('-').map(capitalize).join(' ');
    },
  },
  ['participationType']: {
    valueFormatter: capitalizer,
    cellClass: ['text-align-right'],
  },
  ['liquidationPreference']: {
    valueGetter: (params) => getLiquidationPreference(params.data),
  },
  ['participationCap']: {
    valueFormatter: (params: ValueFormatterParams) => {
      const formatter = FormatterService.get().getFormatterForFormField({
        renderer: RendererType.multiplier,
        key: 'participationCap',
      });
      if (params.value != null) {
        return formatter(params.value);
      } else if (!params.node?.footer && !params.node?.group) {
        return 'N/A';
      } else {
        return '';
      }
    },
  },
};

function capitalizer(params: ValueFormatterParams) {
  return params.value != null ? capitalize(params.value) : '';
}
